import { useMutation } from "@tanstack/react-query";
import { useNotification } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { IntegrationEndpoint } from "@modules/erpIntegrations/types";
import { getErpErrorMessage } from "@modules/erpIntegrations/utils";

import { editEndpointService } from "./service";
import { EditEndpointVariables, UseEditEndpointMutationOptions } from "./types";

export function useEditEndpointMutation(options?: UseEditEndpointMutationOptions) {
  const { open } = useNotification();

  return useMutation<IntegrationEndpoint, ApiError, EditEndpointVariables>({
    mutationFn: editEndpointService,
    onError: (error) => {
      open?.({
        type: "error",
        message: getErpErrorMessage(error),
      });
    },
    ...options,
  });
}
